import styled from 'styled-components'

export const PrimaryButton = styled.button`
  width: 100%;
  background: ${props => props.theme.colors.text.primary};
  color: ${props => props.theme.colors.background.primary};
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: ${props => props.theme.radius.button};
  font-size: 0.875rem;
  font-weight: 500;
  font-family: ${props => props.theme.typography.fontFamily};
  cursor: pointer;
  transition: ${props => props.theme.transitions.button};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: ${props => props.marginTop || '1.25rem'};

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px ${props => props.theme.colors.shadow.medium};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
